import Hightlighter from 'react-highlight-words';
import * as S from './ChooseAdvertisers.styled';
import { Checkbox } from 'components';

export const Content = ({ foundedAdvetisers, search, isActive, toggle }) => {
  return (
    <S.ItemsGroup>
      {foundedAdvetisers?.map(({ pb_name, pb_number }) => (
        <S.Group key={pb_number}>
          <S.Row>
            <Checkbox
              id={`${pb_number}`}
              isChecked={isActive(pb_number)}
              name={pb_number}
              onChange={toggle}
            />
            <S.GroupName onClick={() => toggle(true, pb_number)}>
              <Hightlighter
                textToHighlight={pb_name}
                searchWords={[search]}
                highlightTag='strong'
              />
            </S.GroupName>
          </S.Row>
        </S.Group>
      ))}
    </S.ItemsGroup>
  );
};
